const welcomes = [
"Welkom",
"Mir se vjên",
"Ahla w sahla",
"Bienvenius",
"Pari yegak",
"Xoş gəlmişsiniz",
"Še das d kemma bisd",
"Pryvitańnie",
"Welkam",
"Dobrodošli",
"Dobre došli",
"欢迎光临",
"Boolkhent",
"Vítej",
"Tere tulemast",
"Tervetuloa",
"Bienvenue",
"Wolkom",
"Welkom",
"Willkommen",
"Aspádzomai",
"Tikilluarit",
"Byen venu",
"Baruch Haba",
"Svāgat",
"Üdvözlet",
"Velkomin",
"Qaimarutin",
"Benvenuto",
"ようこそ",
"Witôj",
"환영합니다",
"Tu be xér hatî ye",
"Taŋyáŋ yahí",
"Dobredojde",
"Swagatam",
"Benvegnüu",
"Siyalemukela",
"Swagatam",
"Bures boahtin",
"Velkommen",
"Benvengut",
"Witam",
"Bem-vindos",
"jī āiā nū̃",
"Bine ai venit",
"Dobro požalovat’",
"Dobrodošli",
"Bienvenido",
"Wamukelekile",
"Välkommen",
"Maeva",
"Huš omaded",
"Talitali fiefia",
"Hoş geldin",
"Laskavo prosymo",
"Xush kelibsiz",
"Benvignùo",
"Croeso",
"Kíimak oolal",
"Ngiyakwemukela"
];

export default welcomes;



// WEBPACK FOOTER //
// ./src/utils/welcomes.js